import ServiceBase from "base/baseService"
import { createCodeDescriptionObject, mountString, numberToBool, } from "helper/formater"
import server from "infra/server"
import * as yup from "yup"

const CST_TABLES = {
    icms_cst: {
        url: '/cadastro/fiscal/icmscst',
        optionKey: 'codigo_icmcst',
        optionLabel: 'descricao_icmcst'
    },
    ipi_cst: {
        url: '/cadastro/fiscal/ipicst',
        optionKey: 'codigo_ipicst',
        optionLabel: 'descricao_ipicst'
    },
    pis_cst: {
        url: '/cadastro/fiscal/piscst',
        optionKey: 'codigo_piscst',
        optionLabel: 'descricao_piscst'
    },
    cofins_cst: {
        url: '/cadastro/fiscal/cofinscst',
        optionKey: 'codigo_cofcst',
        optionLabel: 'descricao_cofcst'
    },
    iss_cst: {
        url: '/cadastro/fiscal/isscst',
        optionKey: 'codigo_isscst',
        optionLabel: 'descricao_isscst'
    },
    ibs_cst: {
        url: '/cadastro/fiscal/ibscst',
        optionKey: 'codigo_ibscst',
        optionLabel: 'descricao_ibscst'
    },
    cbs_cst: {
        url: '/cadastro/fiscal/cbscst',
        optionKey: 'codigo_cbscst',
        optionLabel: 'descricao_cbscst'
    },
    is_cst: {
        url: '/cadastro/fiscal/iscst',
        optionKey: 'codigo_iscst',
        optionLabel: 'descricao_iscst'
    }
}

export default class OperacaoFiscalService extends ServiceBase {

    title = "Operação fiscal"
    pluralTitle = "Operações fiscais"
    url = '/cadastro/fiscal/operacaofiscal'
    frontUrl = '/cadastro/fiscal/operacaofiscal'
    frontUrlList = '/cadastro/fiscal/operacaofiscallist'
    primaryKey = 'codigo_opefis'
    rowDpl = true
    ignoredsSchemaConvertions = [
        'cod_fiof_opefis',
        'cod_emp_opefis',
        'cod_regit_emp_opefis',
        'cod_linc_opefis',
        'cod_limu_clifor_opefis',
        'cod_liuf_clifor_opefis',
        'cod_lcn_opefis',
        'cod_tilin_opefis',
        'cod_tlcn_opefis',
        'cod_regite_emp_opefis',
        'cod_regit_clifor_opefis',
        'cod_regite_clifor_opefis',
        'cod_uf_clifor_opefis',
        'cod_muni_clifor_opefis',
        'cod_serie_opefis',
        'rete_cod_fupar_opefis',
        'difal_cod_fupar_rec_opefis',
        'cod_modf_opefis',
        'cod_tipe_clifor_opefis',
        'cod_modi_opefis',
        'usu_atua_opefis',
        'formulas_opefis',
        'cod_opefis_ofad',
    ]
    fieldsParaDescricao = [
        'cod_tiof_opefis',
        'cod_fiof_opefis',
        'eh_fora_pais_clifor_opefis',
        'eh_fora_uf_clifor_opefis',
        'eh_fora_muni_clifor_opefis',
        'eh_zfm_clifor_opefis',
        'cod_conp_opefis',
        'cod_modf_opefis',
        'cod_tipp_opefis',
        'cod_tipe_clifor_opefis',
        'cod_orip_opefis',
        'cod_linc_opefis',
        'cod_limu_clifor_opefis',
        'cod_liuf_clifor_opefis',
        'cod_lcn_opefis',
        'cod_tilin_opefis',
        'cod_tlcn_opefis',
        'cod_uf_clifor_opefis',
        'cod_muni_clifor_opefis',
        'cod_serie_opefis',
        'rete_cod_fupar_opefis',
        'cod_modi_opefis',
        'eh_inventario_opefis',
        'eh_prod_defeito_opefis',
        'eh_emiss_propria_opefis',
        'eh_contrib_icms_clifor_opefis',
        'mva_icms_esp_clifor_opefis',
        'eh_presencial_opefis',
        'cod_regit_emp_opefis',
        'cod_regite_emp_opefis',
        'cod_regit_clifor_opefis',
        'cod_regite_clifor_opefis',
        'cod_emp_opefis',
        'ncms_opefis',
        'cests_opefis',
        'ini_vig_opefis',
        'fim_vig_opefis',
        'cod_ope_frete_opefis',
        'cod_ope_seguro_opefis',
        'cod_ope_despesa_opefis',
        'cod_ope_desc_opefis',
        'cod_ope_deson_opefis',
        'cod_ope_rete_opefis',
        'cod_mom_red_bc_opefis',
        'difal_calc_opefis',
        'difal_aliq_int_dest_opefis',
        'difal_aliq_interest_opefis',
        'difal_cod_tci_opefis',
        'difal_cod_fupar_rec_opefis',
        'difal_bc_desc_opefis',
        'difal_bc_fsd_opefis',
        'rete_calc_opefis',
        'cod_cfop_opefis',
        'cod_clastrib_opefis',
        'cod_regbc_opefis',
        'aliq_opefis',
        'cod_tci_opefis',
        'perc_bc_opefis',
        'cod_cst_opefis',
        'cod_piscst_opefis',
        'dir_cred_opefis',
        'codigo_ben_fiscal_opefis',
        'cumul_opefis',
        'st_ret_calc_opefis',
        'efet_calc_opefis',
        'dife_aliq_opefis',
        'dife_calc_opefis',
        'st_mva_opefis',
        'st_calc_opefis',
        'st_perc_bc_opefis',
        'st_aliq_opefis',
        'rete_vlr_min_opefis',
        'envia_xml_nf_opefis',
        'perc_bc_iss_opefis',
        'aliq_iss_opefis',
        'rete_perc_bc_opefis',
        'rete_aliq_opefis',
        'perc_bc_inss_opefis',
        'aliq_inss_opefis',
        'perc_bc_csll_opefis',
        'aliq_csll_opefis',
        'cred_out_calc_opefis',
        'cred_out_perc_bc_opefis',
        'cred_out_aliq_opefis',
        'cod_enquad_opefis',
    ]

    prepareToFront(data = {}) {

        data.edita_opefis = numberToBool(data.edita_opefis)
        data.eh_fora_pais_clifor_opefis = numberToBool(data.eh_fora_pais_clifor_opefis)
        data.eh_fora_uf_clifor_opefis = numberToBool(data.eh_fora_uf_clifor_opefis)
        data.eh_fora_muni_clifor_opefis = numberToBool(data.eh_fora_muni_clifor_opefis)
        data.eh_zfm_clifor_opefis = numberToBool(data.eh_zfm_clifor_opefis)
        data.eh_inventario_opefis = numberToBool(data.eh_inventario_opefis)
        data.eh_prod_defeito_opefis = numberToBool(data.eh_prod_defeito_opefis)
        data.eh_contrib_icms_clifor_opefis = numberToBool(data.eh_contrib_icms_clifor_opefis)
        data.mva_icms_esp_clifor_opefis = numberToBool(data.mva_icms_esp_clifor_opefis)
        data.eh_presencial_opefis = numberToBool(data.eh_presencial_opefis)
        data.eh_emiss_propria_opefis = numberToBool(data.eh_emiss_propria_opefis)
        data.obs_nf_imp_opefis = numberToBool(data.obs_nf_imp_opefis)
        data.obs_nf_fisco_opefis = numberToBool(data.obs_nf_fisco_opefis)
        data.cumul_opefis = numberToBool(data.cumul_opefis)
        data.st_ret_calc_opefis = numberToBool(data.st_ret_calc_opefis)
        data.st_calc_opefis = numberToBool(data.st_calc_opefis)
        data.efet_calc_opefis = numberToBool(data.efet_calc_opefis)
        data.mov_estoque_opefis = numberToBool(data.mov_estoque_opefis)
        data.dir_cred_opefis = numberToBool(data.dir_cred_opefis)
        data.envia_xml_nf_opefis = numberToBool(data.envia_xml_nf_opefis)
        data.difal_calc_opefis = numberToBool(data.difal_calc_opefis)
        data.difal_bc_desc_opefis = numberToBool(data.difal_bc_desc_opefis)
        data.difal_bc_fsd_opefis = numberToBool(data.difal_bc_fsd_opefis)
        data.rete_calc_opefis = numberToBool(data.rete_calc_opefis)
        data.dife_calc_opefis = numberToBool(data.dife_calc_opefis)
        data.cred_out_calc_opefis = numberToBool(data.cred_out_calc_opefis)

        // Numéricos com FK notNullable

        data.cod_tiof_opefis = data?.cod_tiof_opefis || null
        data.cod_fiof_opefis = data?.cod_fiof_opefis || null
        data.cod_tri_opefis = data?.cod_tri_opefis || null
        data.cod_cfop_opefis = data?.cod_cfop_opefis || null
        data.cod_clastrib_opefis = data?.cod_clastrib_opefis || null
        data.cod_regbc_opefis = data?.cod_regbc_opefis || null
        data.cod_muni_opefis = data?.cod_muni_opefis || null
        data.cod_liuf_clifor_opefis = data?.cod_liuf_clifor_opefis || null
        data.cod_lcn_opefis = data?.cod_lcn_opefis || null
        data.emp_ins_opefis = data?.emp_ins_opefis || null
        data.cod_ope_frete_opefis = data?.cod_ope_frete_opefis || null
        data.cod_ope_seguro_opefis = data?.cod_ope_seguro_opefis || null
        data.cod_ope_despesa_opefis = data?.cod_ope_despesa_opefis || null
        data.cod_ope_desc_opefis = data?.cod_ope_desc_opefis || null
        data.cod_ope_deson_opefis = data?.cod_ope_deson_opefis || null
        data.cod_ope_rete_opefis = data?.cod_ope_rete_opefis || null
        data.difal_cod_fupar_rec_opefis = data?.difal_cod_fupar_rec_opefis || null

        // Strings notNullable

        data.descricao_opefis = data?.descricao_opefis || ''
        data.cod_cst_opefis = data?.cod_cst_opefis || ''
        data.cod_piscst_opefis = data?.cod_piscst_opefis || ''
        data.cod_tci_opefis = data?.cod_tci_opefis || 'd'
        data.cod_mom_red_bc_opefis = data?.cod_mom_red_bc_opefis || 'a'
        data.difal_cod_tci_opefis = data?.difal_cod_tci_opefis || 'd'
        data.codigo_ben_fiscal_opefis = data?.codigo_ben_fiscal_opefis || ''
        data.obs_nf_opefis = data?.obs_nf_opefis || ''
        data.formulas_opefis = data?.formulas_opefis || ''
        // Dependentes

        data.operacao_fiscal_ad = data?.operacao_fiscal_ad || []

        // Numéricos sem FK

        data.perc_bc_opefis = data?.perc_bc_opefis || 0
        data.aliq_opefis = data?.aliq_opefis || 0
        data.st_perc_bc_opefis = data?.st_perc_bc_opefis || 0
        data.st_aliq_opefis = data?.st_aliq_opefis || 0
        data.st_mva_opefis = data?.st_mva_opefis || 0
        data.dife_aliq_opefis = data?.dife_aliq_opefis || 0
        data.difal_aliq_int_dest_opefis = data?.difal_aliq_int_dest_opefis || 0
        data.difal_aliq_interest_opefis = data?.difal_aliq_interest_opefis || 0
        data.cod_enquad_opefis = data?.cod_enquad_opefis || null

        data.rete_vlr_min_opefis = data?.rete_vlr_min_opefis || 0

        data.perc_bc_iss_opefis = data?.perc_bc_iss_opefis || 0
        data.aliq_iss_opefis = data?.aliq_iss_opefis || 0
        data.rete_perc_bc_opefis = data?.rete_perc_bc_opefis || 0
        data.rete_aliq_opefis = data?.rete_aliq_opefis || 0
        data.perc_bc_inss_opefis = data?.perc_bc_inss_opefis || 0
        data.aliq_inss_opefis = data?.aliq_inss_opefis || 0
        data.perc_bc_csll_opefis = data?.perc_bc_csll_opefis || 0
        data.aliq_csll_opefis = data?.aliq_csll_opefis || 0
        data.cred_out_perc_bc_opefis = data?.cred_out_perc_bc_opefis || 0
        data.cred_out_aliq_opefis = data?.cred_out_aliq_opefis || 0

        // Dependentes

        // Datas

        data.ini_vig_opefis = data?.ini_vig_opefis ? new Date(data.ini_vig_opefis) : null
        data.fim_vig_opefis = data?.fim_vig_opefis ? new Date(data.fim_vig_opefis) : null

        console.log('THE DATAS:', data)

        return data
    }

    prepareToSave({ data }) {

        if (data?.cod_cfop_opefis?.codigo_cfop) data.cod_cfop_opefis = data.cod_cfop_opefis.codigo_cfop
        if (data?.cod_clastrib_opefis?.codigo_clastrib) data.cod_clastrib_opefis = data.cod_clastrib_opefis.codigo_clastrib
        if (data?.cod_regbc_opefis?.codigo_regbc) data.cod_regbc_opefis = data.cod_regbc_opefis.codigo_regbc
        if (data?.cod_muni_clifor_opefis?.codigo_muni) data.cod_muni_clifor_opefis = data.cod_muni_clifor_opefis.codigo_muni
        if (data?.cod_ope_frete_opefis?.codigo_ope) data.cod_ope_frete_opefis = data.cod_ope_frete_opefis.codigo_ope
        if (data?.cod_ope_seguro_opefis?.codigo_ope) data.cod_ope_seguro_opefis = data.cod_ope_seguro_opefis.codigo_ope
        if (data?.cod_ope_despesa_opefis?.codigo_ope) data.cod_ope_despesa_opefis = data.cod_ope_despesa_opefis.codigo_ope
        if (data?.cod_ope_desc_opefis?.codigo_ope) data.cod_ope_desc_opefis = data.cod_ope_desc_opefis.codigo_ope
        if (data?.cod_ope_deson_opefis?.codigo_ope) data.cod_ope_deson_opefis = data.cod_ope_deson_opefis.codigo_ope
        if (data?.cod_ope_rete_opefis?.codigo_ope) data.cod_ope_rete_opefis = data.cod_ope_rete_opefis.codigo_ope
        if (data?.cod_mom_red_bc_opefis?.codigo_mom) data.cod_mom_red_bc_opefis = data.cod_mom_red_bc_opefis.codigo_mom
        if (data?.difal_cod_fupar_rec_opefis?.codigo_fupar) data.difal_cod_fupar_rec_opefis = data.difal_cod_fupar_rec_opefis.codigo_fupar

        if (data.operacaoFiscalAdRemoved?.length) {
            data.operacao_fiscal_ad = data.operacao_fiscal_ad || []
            data.operacao_fiscal_ad.push(...data.operacaoFiscalAdRemoved.map(item => ({ action: 'del', ...item })))
        }
        if ('operacaoFiscalAdRemoved' in data) delete data.operacaoFiscalAdRemoved

        return data
    }
    /**
     * 
     * Adiciona o elemento na lista de Watch antes de usar.
     */
    mountDescricao({ operacaoFiscal, tipoOperacaoFiscals, finalidadeOperacaoFiscals, ufs, series, motivoDesoneraIcmss, regimeTributacaos, listaMunicipios, listaUfs, listaCestNcms, tipoListaCestNcms, listaNcms, tipoListaNcms, regimeBaseCalculos }) {

        const ds = new mountString()

        const initials = (phrase) =>
            phrase
                .trim()
                .split(/\s+/)
                .map(w => w.normalize('NFD').replace(/[^a-zA-Z]/g, '')) // remove acentos e símbolos
                .filter(w => w.length > 0)
                .map(w => w[0].toUpperCase())
                .join('')


        const locate = (base, record, pk, fk, rsField) => {
            if (record[fk]) {
                const elem = base.find(e => e[pk] === record[fk])
                if (elem) return elem[rsField]
            }
            return ''
        }

        const regitEmp = locate(regimeTributacaos, operacaoFiscal, 'codigo_regit', 'cod_regit_emp_opefis', 'descricao_regit').split('-')
        const regitEEmp = locate(regimeTributacaos, operacaoFiscal, 'codigo_regit', 'cod_regite_emp_opefis', 'descricao_regit').split('-')
        const regitClifor = locate(regimeTributacaos, operacaoFiscal, 'codigo_regit', 'cod_regit_clifor_opefis', 'descricao_regit').split('-')
        const regitEClifor = locate(regimeTributacaos, operacaoFiscal, 'codigo_regit', 'cod_regite_clifor_opefis', 'descricao_regit').split('-')

        ds.add(String(operacaoFiscal.cod_emp_opefis || ''), 'EMP-')
        ds.addKeyless(locate(tipoOperacaoFiscals, operacaoFiscal, 'codigo_tiof', 'cod_tiof_opefis', 'descricao_tiof'))
        ds.addKeyless(locate(finalidadeOperacaoFiscals, operacaoFiscal, 'codigo_fiof', 'cod_fiof_opefis', 'descricao_fiof'))

        ds.addBool(operacaoFiscal.eh_presencial_opefis, 'PRESENCIAL', 'NÃO PRESENCIAL')

        ds.addKeyless(locate(listaMunicipios, operacaoFiscal, 'codigo_limu', 'cod_limu_clifor_opefis', 'descricao_limu'))
        ds.addKeyless(locate(listaUfs, operacaoFiscal, 'codigo_liuf', 'cod_liuf_clifor_opefis', 'descricao_liuf'))
        ds.addKeyless(locate(listaCestNcms, operacaoFiscal, 'codigo_lcn', 'cod_lcn_opefis', 'descricao_lcn'))
        ds.add(locate(tipoListaCestNcms, operacaoFiscal, 'codigo_tlcn', 'cod_tlcn_opefis', 'descricao_tlcn'))
        ds.addKeyless(locate(listaNcms, operacaoFiscal, 'codigo_linc', 'cod_linc_opefis', 'descricao_linc'))
        ds.add(locate(tipoListaNcms, operacaoFiscal, 'codigo_tilin', 'cod_tilin_opefis', 'descricao_tilin'))

        ds.add(locate(series, operacaoFiscal, 'codigo_serie', 'cod_serie_opefis', 'sigla_serie'), 'SRE')

        ds.addBool(operacaoFiscal.eh_emiss_propria_opefis, 'PRÓPRIA', 'TERCEIRO')
        ds.addBool(operacaoFiscal.eh_fora_muni_clifor_opefis, 'FORA (CID.)', 'DENTRO (CID.)')
        ds.addBool(operacaoFiscal.eh_fora_uf_clifor_opefis, 'FORA (UF)', 'DENTRO (UF)')
        ds.addBool(operacaoFiscal.eh_fora_pais_clifor_opefis, 'FORA (PAÍS)', 'DENTRO (PAÍS)')
        ds.add(operacaoFiscal?.cod_muni_clifor_opefis?.descricao_muni, '', '-' + operacaoFiscal?.cod_muni_clifor_opefis?.sigla_uf)
        ds.add(locate(ufs, operacaoFiscal, 'codigo_uf', 'cod_uf_clifor_opefis', 'sigla_uf'))
        ds.addByIndex(operacaoFiscal.cod_tipe_clifor_opefis, ['f', 'j'], ['PF', 'PJ'])
        ds.addByIndex(operacaoFiscal.cod_conp_opefis, ['n', 'u', 'r'], ['NOVO', 'USADO', 'REFURBISHED'])
        ds.add(locate(motivoDesoneraIcmss, operacaoFiscal, 'codigo_modi', 'cod_modi_opefis', 'sigla_modi'))

        ds.add(operacaoFiscal.cod_modf_opefis, 'DOC-')
        ds.add(operacaoFiscal.cod_tipp_opefis, 'TIPO PRD-')
        ds.add(operacaoFiscal.cod_orip_opefis, 'ORIG-')
        ds.addBool(operacaoFiscal.eh_zfm_clifor_opefis, 'ZF', 'NÃO ZF')
        ds.addBool(operacaoFiscal.eh_inventario_opefis, 'INV.', 'NÃO INV.')
        ds.addBool(operacaoFiscal.eh_prod_defeito_opefis, 'DEFEITO', 'NÃO DEFEITO')
        ds.addBool(operacaoFiscal.eh_contrib_icms_clifor_opefis, 'CONTRIB', 'NÃO CONTRIB')
        ds.addBool(operacaoFiscal.mva_icms_esp_clifor_opefis, 'MVA-ESPECIAL', 'SEM MVA-ESP')

        if (regitEmp.length > 1) ds.add(initials(regitEmp[1]), 'REG-')
        if (regitEEmp.length > 1) ds.add(initials(regitEEmp[1]), 'REG/ESP-')
        if (regitClifor.length > 1) ds.add(initials(regitClifor[1]), 'REG.CLI/FOR-')
        if (regitEClifor.length > 1) ds.add(initials(regitEClifor[1]), 'REG.CLI/FOR/ESP-')

        if (operacaoFiscal.ncms_opefis?.length > 16) ds.add('VÁRIOS NCMs')
        else ds.add(operacaoFiscal.ncms_opefis, 'NCM-')

        if (operacaoFiscal.cests_opefis?.length > 16) ds.add('VÁRIOS CESTs')
        else ds.add(operacaoFiscal.cests_opefis, 'CEST-')

        ds.add(operacaoFiscal?.ini_vig_opefis?.toLocaleDateString(), 'VIG.INI-')
        ds.add(operacaoFiscal?.fim_vig_opefis?.toLocaleDateString(), 'VIG.FIM-')

        /**
         * APLICAÇÃO
        */

        const aplica = new mountString()


        // ICMS

        aplica.add(operacaoFiscal?.cod_cfop_opefis?.codigo_cfop, 'C')
        aplica.add(operacaoFiscal?.cod_clastrib_opefis?.codigo_clastrib, 'CLAS.TRIB')
        aplica.add(operacaoFiscal?.cod_cst_opefis, 'CST')
        aplica.add(operacaoFiscal?.codigo_ben_fiscal_opefis, 'BENEF. ')
        aplica.addBool(operacaoFiscal.cumul_opefis, 'CUMULAT.', '')
        aplica.addBool(operacaoFiscal.efet_calc_opefis, 'ICMS EFETIVO', '')
        aplica.add(operacaoFiscal?.perc_bc_opefis, 'BC', '%')
        aplica.add(operacaoFiscal?.aliq_opefis, 'AL', '%')

        aplica.add(operacaoFiscal?.st_mva_opefis, 'MVA', '%')
        aplica.add(operacaoFiscal?.st_perc_bc_opefis, 'BCST', '%')
        aplica.add(operacaoFiscal?.st_aliq_opefis, 'ALST', '%')
        aplica.addBool(operacaoFiscal.st_calc_opefis, 'ST', '')

        aplica.addBool(operacaoFiscal.st_ret_calc_opefis, 'RET. ICMS/FCP', '')
        aplica.addBool(operacaoFiscal.difal_calc_opefis, 'DIFAL', '')
        aplica.add(operacaoFiscal?.difal_aliq_int_dest_opefis, 'AL.INT DEST', '%')
        aplica.add(operacaoFiscal?.difal_aliq_interest_opefis, 'AL.INTEREST', '%')
        aplica.add(operacaoFiscal?.difal_cod_tci_opefis, 'TCI DIFAL-')
        aplica.addBool(operacaoFiscal.difal_bc_desc_opefis, 'DIFAL DESC', '')
        aplica.addBool(operacaoFiscal.difal_bc_fsd_opefis, 'DIFAL FRETE', '')

        // ISS

        aplica.add(operacaoFiscal?.rete_vlr_min_opefis, 'SE VLR >')

        aplica.add(operacaoFiscal?.perc_bc_iss_opefis, 'BC.ISS', '%')
        aplica.add(operacaoFiscal?.aliq_iss_opefis, 'AL.ISS', '%')
        aplica.add(operacaoFiscal?.rete_perc_bc_opefis, 'BC.RET', '%')
        aplica.add(operacaoFiscal?.rete_aliq_opefis, 'AL.RET', '%')
        aplica.add(operacaoFiscal?.perc_bc_inss_opefis, 'BC.INSS', '%')
        aplica.add(operacaoFiscal?.aliq_inss_opefis, 'AL.INSS', '%')
        aplica.add(operacaoFiscal?.perc_bc_csll_opefis, 'BC.CSLL', '%')
        aplica.add(operacaoFiscal?.aliq_csll_opefis, 'AL.CSLL', '%')
        aplica.addBool(operacaoFiscal.rete_calc_opefis, 'RETENÇÃO', '')

        const reterPrestadores = []
        const reterTomadores = []

        if (operacaoFiscal.rete_cod_fupar_opefis === 1) reterPrestadores.push('ISS')

        if (operacaoFiscal.rete_cod_fupar_opefis === 2) reterTomadores.push('ISS')

        if (reterPrestadores.length) {
            aplica.add(`Prestador retém (${reterPrestadores.join(',')})`)
        }
        if (reterTomadores.length) {
            aplica.add(`Tomador retém (${reterTomadores.join(',')})`)
        }

        aplica.add(operacaoFiscal?.cod_enquad_opefis, 'ENQ-')

        // GERAIS

        aplica.addBool(operacaoFiscal.envia_xml_nf_opefis, 'Tag na NFS-e', '')

        aplica.add(locate(regimeBaseCalculos, operacaoFiscal, 'codigo_regbc', 'cod_regbc_opefis', 'descricao_regbc'), 'BC-')
        aplica.addBool(operacaoFiscal.dife_calc_opefis, 'DIFERIMENTO', '')
        aplica.add(operacaoFiscal?.dife_aliq_opefis, 'AL DIFERIMENTO', '%')
        aplica.addBool(operacaoFiscal.cred_out_calc_opefis, 'CRÉD. OUTORG', '')
        aplica.add(operacaoFiscal?.cred_out_perc_bc_opefis, 'BC CRÉD.OUT', '%')
        aplica.add(operacaoFiscal?.cred_out_aliq_opefis, 'AL CRÉD.OUT', '%')

        // ADICIONA NA DS
        let drawDs = ''

        if (ds.len() && aplica.len()) {
            drawDs = ds.toString().capitalized() + ' | ' + aplica.toString().capitalized()
        } else {
            drawDs = ds.toString().capitalized()
        }

        if (drawDs.length > 254) drawDs = drawDs.substring(0, 251) + '...'

        return drawDs

    }

    async getSchema() {

        return super.getSchema().then((data) => {

            if (data?.fields) {

                data.fields.cod_cfop_opefis = yup.object()
                    .test('CFOP', 'Inválido', e => e.codigo_cfop)
                    .required('Obrigatório')

                data.fields.cod_clastrib_opefis = yup.object()
                    .test('Classificação', 'Inválido', e => e?.codigo_clastrib)
                    .required('Obrigatório')

                data.fields.cod_mom_red_bc_opefis = yup.string()
                    .required('Obrigatório')

                // data.fields.cod_regbc_opefis = yup.number()
                //     .test('Regime de BC', 'Inválido', e => e.codigo_regbc == null).required('Obrigatório').typeError('Valor inválido!')
            }

            return data

        })

    }

    getCstConfig(codigo_tabcst = 'icms_cst') {
        return CST_TABLES[codigo_tabcst] || CST_TABLES.icms_cst
    }

    async cstList(codigo_tabcst = 'icms_cst') {

        const config = this.getCstConfig(codigo_tabcst)
        const response = await server().get(config.url)
        const list = response?.data?.data ?? []
        return {
            ...config,
            list: list.map(item => createCodeDescriptionObject(item, config.optionKey, config.optionLabel, true))
        }

    }

    setObjectTributo(tributo) {

        return createCodeDescriptionObject(tributo, 'codigo_tri', 'descricao_tri', false,
            ['sigla_tri', 'cod_tabcst_tri', 'campos_opefis_tri', 'serv_tri', 'merc_tri'])

    }

    getNewOperacaoFiscalAd(data = {}) {

        return {
            action: 'ins',
            cod_opefis_ofad: null,
            cod_tiv_ofad: 'bc:v',
            cod_ope_ofad: 'a',
            cod_tri_ofad: null,
            ...data
        }
    }

    getLabelOfAdicionarTributo({ operacaoFiscalAd }) {

        let label = ''

        if (operacaoFiscalAd?.cod_ope_ofad === 'a') label += 'Adicionar'
        else if (operacaoFiscalAd?.cod_ope_ofad === 'd') label += 'Deduzir'

        if (operacaoFiscalAd?.cod_tiv_ofad === 'bc:v') label += ' a BC'
        else if (operacaoFiscalAd?.cod_tiv_ofad === 'v') label += ' o valor'

        label += ' do:'

        return label

    }



}
